"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _extends3 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _qs = _interopRequireDefault(require("qs"));
var _base = _interopRequireDefault(require("./base"));
var _consts = require("../utils/consts");
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
/**
 * `Service` The PackageDetail service
 */
var PackageDetail = /*#__PURE__*/function (_Base) {
  /**
   * Create the package detail service instance.
   *
   * @param sdk - the SDK instance
   */
  function PackageDetail(sdk) {
    (0, _classCallCheck2["default"])(this, PackageDetail);
    return _callSuper(this, PackageDetail, [sdk]);
  }

  /**
   * Static getter of the class name
   *
   * @returns The detail property name used by SDK instance.
   */
  (0, _inherits2["default"])(PackageDetail, _Base);
  return (0, _createClass2["default"])(PackageDetail, [{
    key: "getPackageInfo",
    value: (
    /**
     * Get package info
     * https://platform.stoplight.autodesk.com/docs/acc-packages-service/reference/ACC-Packages-Management.yaml/paths/~1projects~1%7BprojectId%7D~1packages~1%7BpackageId%7D/get
     *
     * @param projectId -  the project uuid
     * @param packageId - the package uuid
     * @param config - object for overwrite request parameters
     * @returns promise with shape of package
     */
    function () {
      var _getPackageInfo = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee(projectId, packageId, config) {
        var url, res;
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              url = "/projects/".concat(projectId, "/packages/").concat(packageId);
              _context.next = 3;
              return this.HttpService.pkgV1.get(url, config);
            case 3:
              res = _context.sent;
              return _context.abrupt("return", res.data);
            case 5:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function getPackageInfo(_x, _x2, _x3) {
        return _getPackageInfo.apply(this, arguments);
      }
      return getPackageInfo;
    }()
    /**
     * Get package activities
     * https://platform.stoplight.autodesk.com/docs/acc-packages-service/branches/master/375b929ff33d9-get-package-activities-api
     *
     * @param projectId -  the project uuid
     * @param packageId - the package uuid
     * @param params - includes \{ limit, nextAnchor \}
     * @param config - object for overwrite request parameters
     * @returns promise with shape of package
     */
    )
  }, {
    key: "getPackageActivities",
    value: (function () {
      var _getPackageActivities = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee2(projectId, packageId, params, config) {
        var query, url, res;
        return _regenerator["default"].wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              query = _qs["default"].stringify(params, {
                addQueryPrefix: true
              });
              url = "/projects/".concat(projectId, "/packages/").concat(packageId, "/activities").concat(query);
              _context2.next = 4;
              return this.HttpService.pkgV1.get(url, config);
            case 4:
              res = _context2.sent;
              return _context2.abrupt("return", res.data);
            case 6:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function getPackageActivities(_x4, _x5, _x6, _x7) {
        return _getPackageActivities.apply(this, arguments);
      }
      return getPackageActivities;
    }()
    /**
     * Get package resource info
     * https://platform.stoplight.autodesk.com/docs/acc-packages-service/a4ddd46700b8b-get-resources-info-api
     *
     * @param projectId -  the project uuid
     * @param packageId - the package uuid
     * @param params - The query parameters
     * @param config - object for overwrite request parameters
     * @returns promise with shape of package
     */
    )
  }, {
    key: "getPackageResourcesInfo",
    value: (function () {
      var _getPackageResourcesInfo = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee3(projectId, packageId, params, config) {
        var query, url, res;
        return _regenerator["default"].wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              query = _qs["default"].stringify(params, {
                addQueryPrefix: true
              });
              url = "/projects/".concat(projectId, "/packages/").concat(packageId, "/resources-info").concat(query);
              _context3.next = 4;
              return this.HttpService.pkgV1.get(url, config);
            case 4:
              res = _context3.sent;
              return _context3.abrupt("return", res.data);
            case 6:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function getPackageResourcesInfo(_x8, _x9, _x10, _x11) {
        return _getPackageResourcesInfo.apply(this, arguments);
      }
      return getPackageResourcesInfo;
    }()
    /**
     * List package resource
     * https://platform.stoplight.autodesk.com/docs/acc-packages-service/reference/ACC-Packages-Management.yaml/paths/~1projects~1%7BprojectId%7D~1packages~1%7BpackageId%7D~1resources/get
     *
     * @param projectId -  the project uuid
     * @param packageId - the package uuid
     * @param params - includes \{ limit, offset \}
     * @param config - object for overwrite request parameters
     * @returns promise with shape of package
     */
    )
  }, {
    key: "getPackageResources",
    value: (function () {
      var _getPackageResources = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee4(projectId, packageId, params, config) {
        var query, url, res;
        return _regenerator["default"].wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              query = _qs["default"].stringify(params, {
                addQueryPrefix: true
              });
              url = "/projects/".concat(projectId, "/packages/").concat(packageId, "/resources").concat(query);
              _context4.next = 4;
              return this.HttpService.pkgV1.get(url, config);
            case 4:
              res = _context4.sent;
              return _context4.abrupt("return", res.data);
            case 6:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
      function getPackageResources(_x12, _x13, _x14, _x15) {
        return _getPackageResources.apply(this, arguments);
      }
      return getPackageResources;
    }()
    /**
     * Add package resource
     * https://platform.stoplight.autodesk.com/docs/acc-packages-service/reference/ACC-Packages-Management.yaml/paths/~1projects~1%7BprojectId%7D~1packages~1%7BpackageId%7D~1resources:batch-add/post
     *
     * @param projectId -  the project uuid
     * @param packageId - the package uuid
     * @param payload - \{ items, force \}
     * @param config - object for overwrite request parameters
     * @returns promise with shape of package
     */
    )
  }, {
    key: "addPackageResources",
    value: (function () {
      var _addPackageResources = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee5(projectId, packageId, payload, config) {
        var url, res;
        return _regenerator["default"].wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              url = "/projects/".concat(projectId, "/packages/").concat(packageId, "/resources:batch-add");
              _context5.next = 3;
              return this.HttpService.pkgV1.post(url, payload, config);
            case 3:
              res = _context5.sent;
              return _context5.abrupt("return", res.data);
            case 5:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this);
      }));
      function addPackageResources(_x16, _x17, _x18, _x19) {
        return _addPackageResources.apply(this, arguments);
      }
      return addPackageResources;
    }()
    /**
     * Delete package resource
     * https://platform.stoplight.autodesk.com/docs/acc-packages-service/reference/ACC-Packages-Management.yaml/paths/~1projects~1%7BprojectId%7D~1packages~1%7BpackageId%7D~1resources:batch-delete/post
     *
     * @param projectId -  the project uuid
     * @param packageId - the package uuid
     * @param items - array of version uuid
     * @param config - object for overwrite request parameters
     * @returns promise with shape of package
     */
    )
  }, {
    key: "deletePackageResources",
    value: (function () {
      var _deletePackageResources = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee6(projectId, packageId, items, config) {
        var url, res;
        return _regenerator["default"].wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              url = "/projects/".concat(projectId, "/packages/").concat(packageId, "/resources:batch-delete");
              _context6.next = 3;
              return this.HttpService.pkgV1.post(url, items, config);
            case 3:
              res = _context6.sent;
              return _context6.abrupt("return", res.data);
            case 5:
            case "end":
              return _context6.stop();
          }
        }, _callee6, this);
      }));
      function deletePackageResources(_x20, _x21, _x22, _x23) {
        return _deletePackageResources.apply(this, arguments);
      }
      return deletePackageResources;
    }()
    /**
     * Export files from package
     * The response is in Camel Case format.
     * https://platform.stoplight.autodesk.com/docs/acc-packages-service/reference/ACC-Packages-Management.yaml/paths/~1projects~1%7BprojectId%7D~1packages~1%7BpackageId%7D~1actions/post
     *
     * @param projectId - the project uuid
     * @param packageId - the package uuid
     * @param data - includes \{
     *   data: \{
     *       documents:[],                 array[string], the version urn array for exporting
     *       options: \{
     *        type,                       string, the exporting markup type, enum: markups, progressTracking
     *         skipActivity,               boolean, if to skip sending activity, default: false
     *         outputFileName,             string, the exported file name
     *         outputType,                 string, default: pdf, and only support pdf now, enum: pdf, zip
     *         standardMarkups: \{          only work if the type is 'markups'
     *           includePublicMarkups,     boolean, default: true
     *           includePrivateMarkups,    boolean, default: true
     *           includeMarkupLinks,       boolean, default: false
     *         \},
     *         issueMarkups: \{              only work if the type is 'markups'
     *           includePublicMarkups,      boolean, default: false
     *           includeUnpublishedMarkups, boolean, default: false
     *         \},
     *         photoMarkups: \{              only work if the type is 'markups'
     *           includePublicMarkups,      boolean, default: false
     *           includePrivateMarkups,     boolean, default: false
     *         \},
     *         locale,                      string, default: en, should be one of [cs, da, de, en-GB, en, es, fr-CA, fr, it, ja, nl, no, sv, zh-Hans, zh-Hant]
     *       \}
     *    \}
     *  \}
     * @param config - Configurable object for overwrite request parameters.
     * @returns a promise that resolves to an object with the shape \{ actionResponse: \{ jobId: string \}, status: string \}
     */
    )
  }, {
    key: "exportFilesFromPackage",
    value: (function () {
      var _exportFilesFromPackage = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee7(projectId, packageId, data, config) {
        var url, payload, response;
        return _regenerator["default"].wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              url = "/projects/".concat(projectId, "/packages/").concat(packageId, "/actions");
              payload = {
                action: 'EXPORT',
                data: data
              };
              _context7.next = 4;
              return this.HttpService.pkgV1.post(url, payload, config);
            case 4:
              response = _context7.sent;
              return _context7.abrupt("return", response.data || {});
            case 6:
            case "end":
              return _context7.stop();
          }
        }, _callee7, this);
      }));
      function exportFilesFromPackage(_x24, _x25, _x26, _x27) {
        return _exportFilesFromPackage.apply(this, arguments);
      }
      return exportFilesFromPackage;
    }()
    /**
     * Download files from package
     * https://platform.stoplight.autodesk.com/docs/acc-packages-service/reference/ACC-Packages-Management.yaml/paths/~1projects~1%7BprojectId%7D~1packages~1%7BpackageId%7D~1actions/post
     *
     * @param projectId -  the project uuid
     * @param packageId - the package uuid
     * @param data - with shape of \{ downloadType: 'open|download', items: [\{ urn, name, entityType \}] \}
     * @param config - Configurable object for overwrite request parameters.
     * @returns a promise that resolves to an object
     */
    )
  }, {
    key: "downloadFilesFromPackage",
    value: (function () {
      var _downloadFilesFromPackage = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee8(projectId, packageId, data, config) {
        var url, payload, res;
        return _regenerator["default"].wrap(function _callee8$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              url = "/projects/".concat(projectId, "/packages/").concat(packageId, "/actions");
              payload = {
                action: 'DOWNLOAD',
                data: data
              }; // Set withCredentials to true, this is to allow the browser set cookie from the response header
              _context8.next = 4;
              return this.HttpService.pkgV1.post(url, payload, (0, _extends3["default"])({}, config, {
                withCredentials: true
              }));
            case 4:
              res = _context8.sent;
              return _context8.abrupt("return", res.data);
            case 6:
            case "end":
              return _context8.stop();
          }
        }, _callee8, this);
      }));
      function downloadFilesFromPackage(_x28, _x29, _x30, _x31) {
        return _downloadFilesFromPackage.apply(this, arguments);
      }
      return downloadFilesFromPackage;
    }()
    /**
     * Share files from package
     * https://platform.stoplight.autodesk.com/docs/acc-packages-service/reference/ACC-Packages-Management.yaml/paths/~1projects~1%7BprojectId%7D~1packages~1%7BpackageId%7D~1actions/post
     *
     * @param projectId -  the project uuid
     * @param packageId - the package uuid
     * @param data - with shape of
     *                          \{
     *                            type: 'Public'|'AccountDirectory',
     *                            resources: \{urn: string, parentFolder: string\}[],
     *                            parentFolder: string,
     *                            recipients: \{emails?: string[], userIds?: string[], companyOxygenIds?: string[], roleOxygenIds?:string[]\}
     *                            title: string,
     *                            message: string,
     *                            expirationDate: string
     *                          \}
     * @param config - Configurable object for overwrite request parameters.
     * @returns a promise that resolves to an object
     */
    )
  }, {
    key: "shareFilesFromPackage",
    value: (function () {
      var _shareFilesFromPackage = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee9(projectId, packageId, data, config) {
        var _this = this;
        var conf, url, payload, res;
        return _regenerator["default"].wrap(function _callee9$(_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              conf = (0, _extends3["default"])((0, _defineProperty2["default"])({}, _consts.CANCEL_KEYS, {
                getter: function getter() {
                  return _this.shareFilesCancelToken;
                },
                setter: function setter(token) {
                  return _this.shareFilesCancelToken = token;
                },
                clearer: function clearer() {
                  return _this.shareFilesCancelToken = undefined;
                }
              }), config);
              url = "/projects/".concat(projectId, "/packages/").concat(packageId, "/actions");
              payload = {
                action: 'SHARE',
                data: data
              };
              _context9.next = 5;
              return this.HttpService.pkgV1.post(url, payload, conf);
            case 5:
              res = _context9.sent;
              return _context9.abrupt("return", res.data);
            case 7:
            case "end":
              return _context9.stop();
          }
        }, _callee9, this);
      }));
      function shareFilesFromPackage(_x32, _x33, _x34, _x35) {
        return _shareFilesFromPackage.apply(this, arguments);
      }
      return shareFilesFromPackage;
    }()
    /**
     * Share files by bridge from package
     * https://platform.stoplight.autodesk.com/docs/acc-packages-service/reference/ACC-Packages-Management.yaml/paths/~1projects~1%7BprojectId%7D~1packages~1%7BpackageId%7D~1actions/post
     *
     * @param projectId -  the project uuid
     * @param packageId - the package uuid
     * @param data - with shape of
     *                    \{
     *                      sourceProjectId: string,
     *                      targetProjectIds: string[],
     *                      receiverEmails: string[],
     *                      assets: \{ acs_document: [], acs_folder: [] \},
     *                      hasMoreData: boolean,
     *                      filePackageType: string // ENUM: 'to_self', 'to_receiver',
     *                      filePackageName: string
     *                    \}
     * @param config - Configurable object for overwrite request parameters.
     * @returns a promise that resolves to an object
     */
    )
  }, {
    key: "shareByBridgeFromPackage",
    value: (function () {
      var _shareByBridgeFromPackage = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee10(projectId, packageId, data, config) {
        var url, payload, res;
        return _regenerator["default"].wrap(function _callee10$(_context10) {
          while (1) switch (_context10.prev = _context10.next) {
            case 0:
              url = "/projects/".concat(projectId, "/packages/").concat(packageId, "/actions");
              payload = {
                action: 'BRIDGE',
                data: data
              };
              _context10.next = 4;
              return this.HttpService.pkgV1.post(url, payload, config);
            case 4:
              res = _context10.sent;
              return _context10.abrupt("return", res.data);
            case 6:
            case "end":
              return _context10.stop();
          }
        }, _callee10, this);
      }));
      function shareByBridgeFromPackage(_x36, _x37, _x38, _x39) {
        return _shareByBridgeFromPackage.apply(this, arguments);
      }
      return shareByBridgeFromPackage;
    }())
  }], [{
    key: "getName",
    value: function getName() {
      return 'PackageDetail';
    }
  }]);
}(_base["default"]);
var _default = exports["default"] = PackageDetail;